import { useaxios } from "../../../../utils/useaxios";
export default (from, to) => initDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('boss_expense/read.php', { from, to }).then((res) => {
        if (res.status == "ok") {
            initDispatch({ type: 'setexpense', payload: res.expenses });
        } else {
            // clear();
        }
        // setloading(false);
    });
}